import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
import CircleWaveMaterialProperty from "./../material/CircleWaveMaterialProperty";
/**
 * 报警图层
 */
class AlarmLayer extends BaseLayer{

    constructor(options={}){
        options.layerName=options.layerName||CONSTANTS.LAYER.ALARM;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        let riskLevelMap=new Map([
            ['blue','低风险'],
            ['yellow','一般风险'],
            ['orange','较大风险'],
            ['red','重大风险'],
        ])

        data.forEach((obj,index) =>{
            let item={layerName:self.layerName,longitude:obj.x,latitude:obj.y,riskLevelStr:riskLevelMap.get(obj.riskLevel),...obj};
            if(item.longitude && item.latitude){
                let entity=self.getEntityById(item.entityId);
                if(!entity){
                    entity=new Cesium.Entity({
                        position: Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude,45),
                        id:item.entityId,
                        attributes:item,
                        ellipse: {
                            //height: 55,//高度
                            semiMinorAxis: 5,//长半轴
                            semiMajorAxis: 5,//短半轴
                            //圆形扩散波纹效果
                            material: new Cesium.CircleWaveMaterialProperty({
                                duration: 3000,//速度
                                gradient: 0.9,//渐变
                                color: Cesium.Color.fromCssColorString("#f71a1a").withAlpha(0.3),
                                count: 3 //数量
                            }),
                            //disableDepthTestDistance: Number.POSITIVE_INFINITY,
                        },
                        label:{
                            text : item.warnMsg,
                            style:Cesium.LabelStyle.FILL_AND_OUTLINE,
                            fillColor:Cesium.Color.fromCssColorString('#FCF516'),
                            outlineWidth:0,
                            font: "12px Helvetica",
                            showBackground : false,
                            pixelOffset:new Cesium.Cartesian2(10, 0),
                            eyeOffset:new Cesium.Cartesian3(0,0,-item.entityId),
                            //disableDepthTestDistance: Number.POSITIVE_INFINITY
                            //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                        }
                    })
                    self.dataSource.entities.add(entity);
                }
            }
        });
    }
}
export default AlarmLayer;
